import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

/**
 * Cabeçalho de página.
 *
 * O app não tinha nenhum `<h1>`: em todas as rotas o topo dizia "AgriGest" e o
 * usuário se localizava pelo formulário que aparecia primeiro. Sem título não
 * há hierarquia, e a tela inteira vira uma pilha de cartões brancos de mesmo
 * peso — parte grande da sensação de "estranho, não sei o quê".
 *
 * Também é o lugar canônico da ação principal da tela ("Nova conta",
 * "Registrar venda"). Antes cada página inventava a sua, em posições
 * diferentes.
 *
 * @param titulo    nome da tela (vira o <h1>)
 * @param descricao uma linha explicando para que serve; opcional
 * @param icone     chave do registro em `ui/Icon`; opcional
 * @param voltar    { to, label } quando a tela é filha de outra
 * @param acao      { to | onClick, label, icone, variante } ação principal
 * @param children  filtros, contadores ou chips que pertencem ao cabeçalho
 */
export default function PageHeader({ titulo, descricao, icone, voltar, acao, children }) {
  // Nem toda tela tem uma ação de criar: quando o botão é só um apoio ("Como
  // usar o sistema"), ele não pode competir com o verde de ação primária.
  const classeAcao = `${acao?.variante === 'secundaria' ? 'btn-secondary' : 'btn-primary'} page-header__acao`;

  return (
    <header className="page-header">
      {voltar && (
        <Link to={voltar.to} className="page-header__voltar">
          <Icon nome="chevron-direita" tamanho={14} className="page-header__voltar-seta" />
          {voltar.label}
        </Link>
      )}

      <div className="page-header__linha">
        {icone && (
          <span className="page-header__icone" aria-hidden="true">
            <Icon nome={icone} tamanho={20} />
          </span>
        )}

        <div className="page-header__texto">
          <h1 className="page-header__titulo">{titulo}</h1>
          {descricao && <p className="page-header__descricao">{descricao}</p>}
        </div>

        {acao && (
          acao.to
            ? (
              <Link to={acao.to} className={classeAcao}>
                {acao.icone && <Icon nome={acao.icone} tamanho={16} />}
                {acao.label}
              </Link>
            )
            : (
              <button type="button" className={classeAcao} onClick={acao.onClick}>
                {acao.icone && <Icon nome={acao.icone} tamanho={16} />}
                {acao.label}
              </button>
            )
        )}
      </div>

      {children && <div className="page-header__extra">{children}</div>}
    </header>
  );
}
